import { render, staticRenderFns } from "./AcessarAtaItensBtnAditivoApostila.vue?vue&type=template&id=24b0642a"
import script from "./AcessarAtaItensBtnAditivoApostila.vue?vue&type=script&lang=js"
export * from "./AcessarAtaItensBtnAditivoApostila.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaItensBtnAditivoApostila.vue?vue&type=style&index=0&id=24b0642a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports